import React from "react";
import { useDispatch, useSelector } from "react-redux";

import "styles/components/Memberships/detialsCard.scss";
import CreditCardSection from "js/components/Memberships/CreditCardSection";
import DetailSection from "js/components/Memberships/DetailSection";
import PaymentHistorySection from "js/components/Memberships/PaymentHistorySection";
import usePageLoading from "hooks/usePageLoading";
import {
  CardGridSkeleton,
  PageLoadingContainer,
  SlowStateBanner,
  SkeletonHeading,
  SkeletonText,
  TableSkeleton,
} from "js/components/Loading";
import { Button as RetryButton } from "js/components/ui/button";
import { loadMembershipData } from "../../../store/features/memberhsip/membershipActions";

const MembershipGeneral: React.FC = () => {
  const dispatch = useDispatch();
  const { membershipData, loading: membershipLoading } = useSelector(
    (state: any) => state.entities.membership,
  );

  const { showSkeleton, showSlowState, dismissSlowState } = usePageLoading({
    isLoading: membershipLoading || !membershipData,
  });

  const handleRetryFetch = () => {
    dismissSlowState();
    if (membershipData?.id) {
      dispatch(loadMembershipData(membershipData.id));
    }
  };

  const slowStateBanner = showSlowState ? (
    <SlowStateBanner
      actions={
        <RetryButton
          size="sm"
          variant="outline"
          className="border-amber-200 bg-amber-50/70 text-amber-700 hover:bg-amber-50"
          onClick={handleRetryFetch}
        >
          Reintentar
        </RetryButton>
      }
    >
      <p className="font-medium">Esto está tardando más de lo previsto.</p>
      <p>Verifica tu conexión o vuelve a intentarlo en unos segundos.</p>
    </SlowStateBanner>
  ) : null;

  const headerSkeleton = (
    <div className="space-y-3">
      <SkeletonHeading className="h-8 w-64" />
      <SkeletonText className="h-4 w-52" />
    </div>
  );

  const contentSkeleton = (
    <div className="space-y-6">
      <CardGridSkeleton cards={3} />
      <CardGridSkeleton cards={1} />
      <TableSkeleton columns={5} rows={5} />
    </div>
  );

  return (
    <PageLoadingContainer
      showSkeleton={showSkeleton}
      slowState={slowStateBanner}
      headerSkeleton={headerSkeleton}
      contentSkeleton={contentSkeleton}
      className="space-y-6"
    >
      <>
        <div>
          <DetailSection />
        </div>
        <div style={{ marginTop: 30 }}>
          <CreditCardSection />
        </div>
        <div style={{ marginTop: 30 }}>
          <PaymentHistorySection />
        </div>
      </>
    </PageLoadingContainer>
  );
};

export default MembershipGeneral;
